import CaretUp from './CaretUp'

export default CaretUp
// eslint-disable-next-line import/export
export * from './CaretUp'
